import React from "react";
import { motion } from "framer-motion";
import Reveal from "../components/Reveal";
import { useI18n } from "../i18n/I18nProvider";

export default function Services() {
  const { t } = useI18n();
  const items = t.services.items;

  return (
    <section id="services" className="py-32 lg:py-40 bg-[#050505]" data-testid="home-services">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 lg:mb-24">
          <div className="lg:col-span-4">
            <Reveal>
              <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] uppercase text-ink-300">
                <span className="block w-8 h-px bg-rouge" />
                <span>{t.services.eyebrow}</span>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal>
              <h2 className="font-serif-editorial text-4xl sm:text-5xl lg:text-6xl text-ink-100 tracking-tight leading-[1.05]">
                {t.services.title}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-hair">
          {items.map((s, i) => (
            <motion.article
              key={s.k}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              data-cursor={s.k}
              data-testid={`service-${i}`}
              className={`group relative p-8 lg:p-10 border-b border-hair ${
                i % 3 !== 2 ? "lg:border-r" : ""
              } ${i % 2 !== 1 ? "md:border-r lg:border-r-0" : ""} ${
                (i % 3 === 0 || i % 3 === 1) && i < items.length - 1 ? "" : ""
              } hover:bg-[#0c0c0e] transition-colors min-h-[280px] flex flex-col`}
            >
              <div className="text-[10px] tracking-[0.32em] uppercase text-ink-500">{s.tag}</div>
              <h3 className="mt-8 font-serif-editorial text-3xl lg:text-4xl text-ink-100 leading-tight">{s.k}</h3>
              <p className="mt-5 text-ink-300 leading-relaxed text-[15px] flex-1">{s.d}</p>
              <div className="mt-8 flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-ink-300 group-hover:text-ink-100 transition-colors">
                <span>↗</span>
                <span>{i % 2 ? "Discover" : "Découvrir"}</span>
              </div>
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-rouge scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
            </motion.article>
          ))}
          {/* fill last cell elegantly */}
          <div className="hidden lg:flex p-10 border-b border-hair bg-[#070708] items-end">
            <div className="text-ink-500 text-[11px] tracking-[0.22em] uppercase max-w-xs">
              + Direction artistique, scénarisation, post-production, motion design.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
